












































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import { Product, ProductsApi, SubscriptionItem } from '@/api';
import { getProductTrialPlanOptions, FormSelectOption } from '@/models';
import Toast from './display/toast.vue';
import { AxiosError } from 'axios';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
import { TrialService } from '@/services/trial-service';

@Component({
	components: {
		SaveCancelButtons,
		VueCtkDateTimePicker,
	},
})
export default class ProductTrialModal extends Vue {
	@Prop({ required: true, type: Object })
	private product!: Product & { subscriptionitem: SubscriptionItem };

	@Prop({ required: true, type: Function })
	private onComplete!: () => Promise<void>;

	public trialTier: string | null = this.product.subscriptionitem.trialPlan ?? null;
	public trialEndsString: string | null = this.oneMonthTrialDate;
	public modalId: string = 'product-trial-modal';
	public loading: boolean = false;

	private productApi: ProductsApi = new ProductsApi();
	private toast: Toast = new Toast();

	public get trialPlanOptions(): FormSelectOption[] {
		return getProductTrialPlanOptions(this.product);
	}

	public async onSubmit(): Promise<void> {
		this.loading = true;
		if (!this.$auth.user().super) {
			this.trialEndsString = this.formatTrialDate(this.oneMonthTrialDate);
		}
		if (!this.product.id || !this.trialEndsString) {
			this.loading = false;
			return;
		}
		const trialEndTs: number = new Date(this.trialEndsString).getTime() / 1000;
		const trialStartTs: number = new Date().setHours(23, 59, 59, 59) / 1000;
		if (trialStartTs > trialEndTs) {
			this.toast.makeToast('Start date is before end date.', 'Error', 'danger');
			this.loading = false;
			return;
		}
		try {
			await this.productApi.productTrial(this.product.id, {
				data: {
					trialTier: this.trialTier!,
					trialEndDateTs: trialEndTs,
					trialStartDateTs: Math.round(trialStartTs),
				},
			});
			await this.onComplete();
			this.closeModal();
			this.toast.makeToast('Trial plan updated', 'Success', 'success');
		} catch (e) {
			const error: AxiosError = e as AxiosError;
			const responseData = error.response?.data;
			const errorMessage: string =
				responseData?.message ?? responseData?.errors ?? 'Failed to update trial plan';
			this.toast.makeToast(errorMessage, 'Error', 'error');
		} finally {
			this.loading = false;
		}
	}

	public closeModal(): void {
		this.$bvModal.hide(this.modalId);
	}

	public onHidden(): void {
		// Reset the values in case the user comes back.
		this.trialTier = this.product.subscriptionitem.trialPlan ?? null;
		this.trialEndsString = this.oneMonthTrialDate;
	}

	private formatTrialDate(date: string | null): string | null {
		if (!date) {
			return null;
		}
		return moment
			.utc(date)
			.local()
			.format('YYYY-MM-DD');
	}

	public get oneMonthTrialDate(): string | null {
		return moment
			.utc()
			.add(1, 'months')
			.format('YYYY-MM-DD');
	}
}
